import script from "./AntragStep1Header.vue?vue&type=script&setup=true&lang=js"
export * from "./AntragStep1Header.vue?vue&type=script&setup=true&lang=js"

import "./AntragStep1Header.vue?vue&type=style&index=0&id=98a06226&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98a06226"]])

export default __exports__